import { useState, useRef } from "react";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import DriveFolderUploadRoundedIcon from "@mui/icons-material/DriveFolderUploadRounded";
import { useMediaQuery, useTheme } from "@mui/material";

interface EditImagePickerProps {
  onImageSelect: (file: File, preview: string) => void;
  imagePreview: any;
}

export const EditImagePicker: React.FC<EditImagePickerProps> = ({
  onImageSelect,
  imagePreview,
}) => {
  const [hovered, setHovered] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        onImageSelect(file, reader.result as string);
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div
      style={{
        position: "relative",
        width: isMobile ? "180px" : "256px",
        height: isMobile ? "180px" : "256px",
        cursor: "pointer",
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={handleClick}
    >
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handleImageChange}
        style={{ display: "none" }}
      />

      <div
        style={{
          width: isMobile ? "180px" : "256px",
          height: isMobile ? "180px" : "256px",
          borderRadius: "50%",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "1px solid #707070",
          position: "relative",
        }}
      >
        {imagePreview ? (
          <img
            src={imagePreview}
            alt="Prévia"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center top",
            }}
          />
        ) : (
          <DriveFolderUploadRoundedIcon
            style={{ fontSize: 100, color: "#bbb" }}
          />
        )}

        {hovered && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              borderRadius: "50%",
            }}
          >
            <CameraAltIcon style={{ fontSize: 24 }} />
            <span>Alterar Foto</span>
          </div>
        )}
      </div>
    </div>
  );
};
